import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Form, Formik } from 'formik';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import states from 'states-us';
import Button from 'web/components/Button';
import Spinner from 'web/components/Spinner';
import TextInput from 'web/components/form-elements/TextInput';

import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import AlertModal from 'web/components/AlertModal';
import { updateLocation } from 'redux/actions/accountSetting';
import { INITIAL_VALUES, VALIDATION_SCHEMA } from 'web/components/utils/addSubAccountUtils';

import CloseIcon from 'web/assets/images/CloseIcon.png';
import styles from './add-subAccount.module.scss';

const AddSubAccount = ({ buttonName, locationList, index, onChangeHandler, pageLanguageContents }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [isOpen, toggle] = useState(false);

  const territoryStates = states.filter((x) => x.contiguous);

  let stateArr = []
  for (let i = 0; i < territoryStates.length; i++) {
    let obj = {
      value: territoryStates[i].name,
      label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
      isoCode: territoryStates[i].abbreviation
    }
    stateArr.push(obj)
  }

  const handleSubAccount = async (props) => {
    let subAccountArr = [];
    subAccountArr = [
      {
        firstName: props.values.firstName,
        lastName: props.values.lastName,
        email: props.values.email,
        phone: props.values.smsPhNumber ? props.values.smsPhNumber : undefined
      },
    ];
    let data = {
      locationName: locationList[index].locationName,
      purchasingLimit: locationList[index].purchasingLimit,
      corporateSubAccounts: subAccountArr,
    };
    const response = await dispatch(updateLocation(data, token));
    if (response.status === 'FAILURE') {
      if (response.message === "Missing request header 'authId' for method parameter of type String") {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        let indexVal = null
        if (pageLanguageContents?.Backend_Popups) {
          pageLanguageContents.Backend_Popups.forEach((val, index) => {
            if (Object.keys(val)[0] === response.message) {
              indexVal = index
            }
          })
        }
        if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
        else setModalContent(response.message);

        setModalLink('');
        toggleModal();

      }
    } else {
      toggle(!isOpen);

      // to display message from content sheet
      let indexVal = null
      if (pageLanguageContents?.Backend_Popups) {
        pageLanguageContents.Backend_Popups.forEach((val, index) => {
          if (Object.keys(val)[0] === response.message) {
            indexVal = index
          }
        })
      }
      if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
      else setModalContent(response.message);

      onChangeHandler()
      setModalLink('');
      toggleModal();
    }
  };

  return (
    <div className={styles.addLocationContainer}>
      {loaderVisible && <Spinner />}
      <div className={styles.subAccBtn}>
        <Button type='app-green-button'
          handleClick={() => {
            toggle(!isOpen);
          }}>
          {buttonName}</Button>
      </div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className={styles.addLocation}>
        <div className={styles.header}>
          <Button handleClick={() => toggle(!isOpen)}>
            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
          </Button>
          <h3>{pageLanguageContents?.Add_Location_User[0]?.AddLocationUser}</h3>
        </div>
        <ModalBody className={styles.body}>
          <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={VALIDATION_SCHEMA(pageLanguageContents)}
            onSubmit={(values) => {
            }}>
            {(props) => {
              const { isValid, dirty } = props;
              return (
                <>
                  <Form>
                    <div className={`row ${styles.fieldGroup}`}>
                      <div className={`col-md-6 ${styles.field}`}>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location_User[1]?.FirstName}
                          <span className="star">*</span>
                        </p>
                        <TextInput
                          name="firstName"
                          inputType="text"
                          placeholder={
                            pageLanguageContents?.Add_Location_User[1]?.FirstName
                          }
                          showErrorMessages={true}
                        />
                      </div>
                      <div className={`col-md-6 ${styles.field}`}>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location_User[2]?.LastName}
                          <span className="star">*</span>
                        </p>
                        <TextInput
                          name="lastName"
                          inputType="text"
                          placeholder={pageLanguageContents?.Add_Location_User[2]?.LastName}
                          showErrorMessages={true}
                        />
                      </div>
                    </div>
                    <div className={`row ${styles.fieldGroup}`}>
                      <div className={`col-md-6 ${styles.field}`}>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location_User[3].Email}
                          <span className="star">*</span>
                        </p>
                        <TextInput
                          name="email"
                          placeholder={pageLanguageContents?.Add_Location_User[3].Email}
                          maxLength={100}
                          showErrorMessages={true}
                        />
                      </div>
                      <div className={`col-md-6 ${styles.field}`}>
                        <p className="mt-0">
                          {pageLanguageContents?.Add_Location_User[4]?.CellPhoneNumber}
                        </p>
                        <PhoneNumber
                          name="smsPhNumber"
                          placeholder={pageLanguageContents?.Add_Location_User[4]?.CellPhoneNumber}
                          maxLength={12}
                          showErrorMessages={true}
                        />
                      </div>
                    </div>
                    <div className={styles.fieldGroup}>
                      <div className={styles.field}>
                        <Button
                          type="app-green-button submitBtn"
                          handleClick={() => {
                            handleSubAccount(props);
                          }}
                          disabled={!(isValid && dirty)}
                        >
                          {pageLanguageContents?.Add_Location_User[5]?.AddSubAccount}
                        </Button>
                      </div>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};
export default AddSubAccount;